import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

const axios = AxiosConfigExplore();

/**
 * Get current user profile
 * GET /user/profile
 * Response: { id, email, full_name, avatar, role }
 */
export const getUserProfile = async () => {
  const res = await axios.get("/user/profile");
  return res.data;
};

/**
 * Update user profile
 * PATCH /user/profile
 * Payload: { full_name, avatar? }
 * Response: { status, message, data: { id, full_name, email, avatar, updated_at } }
 */
export const updateUserProfile = async ({ full_name, avatar }) => {
  const payload = { full_name };
  if (avatar !== undefined) {
    payload.avatar = avatar;
  }
  const res = await axios.patch("/user/profile", payload);
  return res.data;
};

/**
 * Upload avatar image to S3
 * POST /user/avatar
 * Multipart form data: file
 * Response: { status, message, avatar_url }
 */
export const uploadUserAvatar = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post("/user/avatar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

/**
 * Sign out all other sessions
 * POST /user/sessions/revoke-others
 * Response: { status, revoked_count, message }
 */
export const revokeOtherSessions = async () => {
  const res = await axios.post("/user/sessions/revoke-others");
  return res.data;
};
